import styled from 'styled-components/macro';
import { getFlex } from '../../styled/styleUtils';

export const CodeRendererWrapper = styled.main`
  margin-top: -8rem;
  button.codeToggle {
    ${getFlex()};
    gap: 0.5rem;
    font-size: var(--font-size-1);
    padding: 0.25rem 0.5rem;
    background: none;
    border: none;
    color: var(--color-primary);
    cursor: pointer;
    transition: color 200ms ease-in;
    &:hover {
      color: var(--color-accent-orange);
    }
  }
`;
export const CodeModalOuter = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  z-index: 10;
  justify-content: center;
  align-items: center;
  background-color: rgba(15, 23, 42, 0.2);
  backdrop-filter: blur(2px);
  transition: background-color 350 ms ease;
`;
export const CodeModalWrapper = styled.main`
  background-color: var(--color-white);
  padding: 1rem;
  border-radius: 8px;
  height: 70vh;
  width: 900px;
  display: flex;
  flex-direction: column;
  transition: height 200ms var(--ease-in-out-quad),
    width 400ms var(--ease-in-out-quad);
  .tabs,
  .footerCta,
  .extraCta {
    button {
      border: none;
      cursor: pointer;
      padding: 0.35rem 0.6rem;
      border-radius: 5px;
      margin-right: 0.5rem;
      font-size: var(--fontSize-0);
      background-color: var(--blueGray-50);
      border: 1px solid var(--blueGray-100);
      transition: background-color 200ms ease-in-out, border 200ms ease-in-out;
      &:hover {
        background-color: var(--blue-50);
        border: 1px solid var(--blue-100);
      }
      &[aria-selected='true'] {
        border: 1px solid var(--blue-100);
        background-color: var(--blue-100);
        color: var(--indigo-700);
        font-weight: 600;
      }
    }
  }

  &[aria-expanded='true'] {
    height: 100vh;
    width: 100vw;
  }
`;
export const CodeModalHeader = styled.main`
  ${getFlex('space-between', 'flex-start')};
  padding-bottom: 1rem;
  .extraCta {
    ${getFlex()};
    font-size: 14px;
    .toggle {
      ${getFlex()};
      .switch {
        margin-left: 0.5rem;
      }
    }
    .expandBtn {
      margin-left: 1rem;
      margin-right: 0;
      padding: 4px;
    }
  }
`;
export const CodeModalBody = styled.main`
  flex: 1;
  border: 2px solid var(--blueGray-100);
  border-radius: 7px;
  overflow: hidden;
`;

export const CodePrintPre = styled.pre`
  padding: 1rem !important;
  overflow: auto;
  width: 100%;
  height: 100%;
  font: 'DM Mono';
  user-select: contain;
`;
export const CodeModalFooter = styled.footer`
  padding-top: 1rem;
  .footerCta {
    ${getFlex('space-between')};
    button {
      margin-right: 0;
      color: var(--indigo-700);
      ${getFlex()};
      i {
        margin-right: 0.2rem;
      }
      &[data-success='true'] {
        background-color: var(--emerald-50);
        border: 1px solid var(--emerald-100);
        color: var(--emerald-700);
      }
    }
  }
`;
